var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfigProvider, Select } from "antd";
import './Select.css';
const { Option } = Select;
const SelectComponent = (_a) => {
    var { placeholder, className = '', rtl = false, showSearch = false, width, option, helperText } = _a, props = __rest(_a, ["placeholder", "className", "rtl", "showSearch", "width", "option", "helperText"]);
    const options = option.map((item, i) => {
        return _jsx(Option, Object.assign({ className: 'sansFont', value: item }, { children: item }), i);
    });
    const textAlign = rtl ? 'right' : 'left';
    const dir = rtl ? 'rtl' : 'ltr';
    return (_jsx(ConfigProvider, Object.assign({ direction: dir }, { children: _jsxs("div", Object.assign({ className: 'select-container', style: { float: textAlign, width, textAlign } }, { children: [_jsx(Select, Object.assign({ className: `sansFont ${className}`, style: { float: textAlign, width }, placeholder: placeholder, showSearch: showSearch }, props, { children: options })), helperText && (_jsx("div", Object.assign({ className: 'helperText', style: { float: textAlign, width, textAlign } }, { children: _jsx("label", { children: helperText }) })))] })) })));
};
export default SelectComponent;
